import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_20: FaireProductEntity = {
  token: "driftless-studios-20",
  type: "product",
  name: "Fall Stuff Flannels, Hayrides, Pumpkins - Halloween Decor",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/39b11b135dc1279461db0fd874929bafc18ac5985925b5e7a8820c359e230d2e.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
